require('./accessKeyChangeStep1.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { InputSafe } = require('commonsComponents/inputSafe');

//@constants
const { nonNumericFilter } = require('utilities/stringHelper');
const KEYCODES = require('constants/index');

class AccessKeyChangeStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newKey: props.accessKeys.newKey || '',
            confirmKey: props.accessKeys.confirmKey || '',
            missedKeyTest: 0 // need 4 digits
        };

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNumeric = this.handleNumeric.bind(this);
        this.validateKey = this.validateKey.bind(this);
        this.generateText = this.generateText.bind(this);

        this.fechaNacimiento = props.immProfile.get('fechaNacimiento'); // AAAA-MM-DD
    }

    generateText(missedKeyTest) {
        const liClass = (new Array(5))
            .fill(0)
            .map((x,y) => (y===missedKeyTest-1 ? "access-key-step-one__li-error" : "access-key-step-one__li-normal"));

        return (
            <div className="access-key-step-one__message-text">
                <ul>
                    <li className={liClass[0]}><FormattedText value="profileKeys-suggestion_1" /></li>
                    <li className={liClass[1]}><FormattedText value="profileKeys-suggestion_2" /></li>
                    <li className={liClass[2]}><FormattedText value="profileKeys-suggestion_3" /></li>
                    <li className={liClass[3]}><FormattedText value="profileKeys-suggestion_4" /></li>
                    <li className={liClass[4]}><FormattedText value="profileKeys-suggestion_5" /></li>
                </ul>
            </div>
        );
    }

    handleBlur(evt) {
        const { name, value } = evt.target;
        this.props.setField(name, value.trim());
    }

    handleChange(evt) {
        const { name, value } = evt.target;
        this.props.setField(name, value.trim());

        if (name === "newKey") {
            // This check in top of handle Numeric in the case
            // keyCode 96 is recognized as letters in any device
            const newKey = nonNumericFilter(value).trim();
            let missedKeyTest = this.validateKey(newKey, this.fechaNacimiento);
            const confirmKey = missedKeyTest ? "" : this.state.confirmKey;
            this.setState({ newKey, confirmKey, missedKeyTest });

        } else {
            this.setState({[name]: nonNumericFilter(value).trim()});
        }
    }

    // This event happens first than handleChange
    handleNumeric(evt){
        // If which is not recognized by the device use keycode
        const keyCode = evt.which || evt.keyCode || 0;
        if ((keyCode < KEYCODES.VK_ZERO || keyCode > KEYCODES.VK_NINE)
        && (keyCode < KEYCODES.VK_ZERO_NUMPAD || keyCode > KEYCODES.VK_NINE_NUMPAD)
        && ( keyCode !== KEYCODES.DELETE_KEYCODE) && ( keyCode !== KEYCODES.BACKSPACE_KEYCODE)
        && ( keyCode !== KEYCODES.LEFT_ARROW_KEYCODE) && ( keyCode !== KEYCODES.RIGHT_ARROW_KEYCODE) ){
            evt.preventDefault();
        }
    }

    validateKey(newKey, fechaNacimiento) {
        const ASCENDING = "01234567890";
        const DESCENDING = "09876543210";
        const FOUR_EQUAL = "0000_1111_2222_3333_4444_5555_6666_7777_8888_9999";
        const aaaaNacimiento = fechaNacimiento.substr(0,4);
        const ddmmNacimiento = fechaNacimiento.substr(8,2)+this.fechaNacimiento.substr(5,2);

        if (newKey.length !== 4) { // must be 4 digits long
            return 1;
        } else if (ASCENDING.includes(newKey) || DESCENDING.includes(newKey)) { // cannot be in sequence
            return 2;
        } else if (FOUR_EQUAL.includes(newKey)) { // cannot be same digits
            return 3;
        } else if (aaaaNacimiento === newKey) { // cannot be year of birth
            return 4;
        } else if (ddmmNacimiento === newKey) { // cannot be day/month of birth
            return 5;
        } else {
            return 0;
        }
    }

    render(){
        const { confirmKeyIsValid, newKeyIsValid, newKeyDirty } = this.props.validation;
        const missedKeyTest = this.state.missedKeyTest;
        const { confirmKey } = this.state;

        let sideText;
        if (missedKeyTest || this.state.newKey.length===0) {
            let errorLines = this.generateText(missedKeyTest);
            sideText = (
                <div className="access-key-step-one__message">
                    <span className="access-key-step-one__message-title"><FormattedText value="profileKeys-suggestions" /></span>
                    {errorLines}
                </div>
            );
        }
        let confirmKeyErrorMessage =  formatText('profileKeys-emptyError');
        if (confirmKey.length > 0) {
            confirmKeyErrorMessage = formatText('profileKeys-invalidError');
        }

        return (
            <form>
                <h4 className="access-key-step-one__header">
                    <FormattedText value="profileKeys-step1Title"/>
                </h4>
                <div className="row">
                    <div className="access-key-step-one__section col-xs-6">
                        <div className="access-key-step-one__section">
                            <InputSafe
                                className="access-key-step-one__input"
                                id="newKey"
                                instructionsMessage=""
                                label={formatText('profileKeys-newKeyTitle')}
                                maxLength={4}
                                name="newKey"
                                onBlur={this.handleBlur}
                                onKeyDown={this.handleNumeric}
                                onChange={this.handleChange}
                                type="password"
                                value={this.state.newKey}
                                errorState={!!missedKeyTest && this.state.newKey.length>0 || !newKeyIsValid && !newKeyDirty}
                                errorMessage=""
                            />
                        </div>
                        <div>
                            <InputSafe
                                className="access-key-step-one__input"
                                id="confirmKey"
                                label={formatText('profileKeys-confirmKeyTitle')}
                                instructionsMessage=""
                                disabled={!!this.state.missedKeyTest}
                                maxLength={4}
                                name="confirmKey"
                                onBlur={this.handleBlur}
                                onKeyDown={this.handleNumeric}
                                onChange={this.handleChange}
                                type="password"
                                value={confirmKey}
                                errorState={!missedKeyTest && !confirmKeyIsValid && (confirmKey !== this.state.newKey)}
                                errorMessage={!missedKeyTest && confirmKeyErrorMessage}
                            />
                        </div>
                    </div>
                    <div className="col-xs-6">
                        {sideText}
                    </div>
                </div>
            </form>
        );
    }
}

AccessKeyChangeStep1.propTypes = {
    accessKeys: PropTypes.object,
    setField: PropTypes.func.isRequired,
    validation: PropTypes.object,
    immProfile: PropTypes.object
};

module.exports = AccessKeyChangeStep1;